import template from './report_autoscheduler.html';

class scheduledReportViewModel
{
	constructor (page)
	{
		this.page = page;
		this.show_hide_active_schedules = ko.observable(false);
		this.list = ko.observableArray([]);
		this.process_id = ko.observable();
		this.process_name = ko.observable();
		this.ui_param = ko.observableArray([]);
		this.process = ko.observable();

		this.show_hide_active_schedules.subscribe(() => {
			this.download_list();
		});	
	}

	format_dow (dow)
	{
		if (dow == '0000000')
			dow = '1111111'
		let days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
		return days.filter((day, index) => dow[index] === '1').join(', ');
	}

	format_interval (interval)
	{
		if (!interval || interval === 'N/A') return 'N/A';

		let parts = interval.split(':');
		let hours = parseInt(parts[0], 10);
		let minutes = parseInt(parts[1], 10);
		let formatted_interval = 'Every ';

		if (hours > 0) formatted_interval += `${hours} hours `;
		if (minutes > 0) formatted_interval += `${minutes} minutes`;
		return formatted_interval.trim();
	}

	format_day_time (day_time)
	{
		if (!day_time || day_time === 'N/A') return 'N/A';
		let parts = day_time.split(':');
		return parts[0] + ':' + parts[1];
	}

	async download_list ()
	{
		let results;
		if (this.show_hide_active_schedules() === false)
		{
			results = await Grape.fetches.getJSON('/api/record', {
				schema: 'reports', 
				table: 'v_report_autoscheduler', 
				filter: [{
					field: 'active',
					operand: '!=',
					value: 'false'
				}]
			});
		}
		else
		{
			results = await Grape.fetches.getJSON('/api/record', {
				schema: 'reports', 
				table: 'v_report_autoscheduler'
			});
		}

		if (results)
		{
			if (results && results.records == null)
				results.records = [];

			this.list(results.records);
		}

		if (results && results.records)
			this.list(results.records);

		//filter: [{field: 'process_name', operand: '=', value: 'report_create'}]
		let process_data = await Grape.fetches.getJSON("/api/record", {
			schema: 'bgworker', 
			table: 'v_processes', 
			filter: [{field: 'process_name', operand: '=', value: 'api_process_create_report'}]
		});

		if (process_data)
		{
			if (process_data.status === "ERROR")
				return;
			else if (process_data.result_count == 0)
				return;
			else
			{
				this.process(process_data.records[0]);
				//Todo remove unused
				let record = process_data.records[0];
				this.process_name(record.process_name);
				this.process_id(record.process_id);
				this.ui_param(record.ui_param);
			}
		}
	}

	btn_show_inactive_click ()
	{
		this.show_hide_active_schedules( !this.show_hide_active_schedules());
	}

	async btn_autoscheduling_click (arg)
	{
		let mode;
		let auto_scheduler;
		let reports_auto_scheduler = {
			version: 1,
			ui_fields: {},
			report_definition_id: 0,
			report_definition_name: '',
			report_autoscheduler_id: 0
		}


		if(arg != undefined)
			mode = 'edit';
		else
			mode = 'create';

		if (Grape.currentSession.roles.indexOf('admin') === -1)
		{
			Grape.alerts.alert({
				type: 'warning',
				message: 'User does not have the correct permission to run autoscheduling',
				title: 'Autoscheduling Error'
			});

			return;
		}
		else
		{
			if (mode === 'edit'){
				let auto_scheduler_id = arg.auto_scheduler_id;
				for (scheduler of this.process().auto_schedulers)
					if (scheduler.auto_scheduler_id == auto_scheduler_id)
						auto_scheduler = scheduler;

				reports_auto_scheduler.version = arg.version;
				reports_auto_scheduler.ui_fields = arg.ui_fields;
				reports_auto_scheduler.report_definition_id = arg.report_definition_id;
				reports_auto_scheduler.group = arg.group;
				reports_auto_scheduler.report_definition_name = arg.report_definition_name;
				reports_auto_scheduler.report_autoscheduler_id = arg.autoscheduler_id;
				

			}
			else
				auto_scheduler = {};

			auto_scheduler.reports_auto_scheduler = reports_auto_scheduler;

			let bindigs_obj = { 
				process: this.process(),
				autoscheduler: auto_scheduler,
				mode: mode
			};

			//let result = await Grape.dialog.open('AutoSchedulerReportsDialog', {process: process, mode: mode});
			let result = await Grape.dialog.open('AutoSchedulerReportsDialog', bindigs_obj);
			if (result)
				this.download_list();
		}
	}

	btn_help_click ()
	{
		// TODO: Grape.show_help does not exist anymore
		// Grape.show_help('/reports/help/report_autoscheduler_help.html');
		console.log('show help clicked');
		Grape.show_dialog('HelpDialog', '/reports/help/report_autoscheduler_help.html', {});
	}
}

class ScheduledReportPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new scheduledReportViewModel(this);
		this.name = 'ScheduledReportPage';
	}

	init ()
	{
		this.viewModel.download_list();
	}
}

export default {
	route: '[/]reports/report_autoscheduler',
	page_class: ScheduledReportPage,
	template: template
}
